import * as ActionTypes from "./ActionTypes";

export const setHowToUseAppList = (data) => {
  return {
    type: ActionTypes.SET_HOW_TO_USE_LIST,
    data,
  };
};
